import { Link } from "react-router-dom";
import { PlayCircle, ArrowRight } from "lucide-react";
import { SHOWCASE_CATEGORIES } from "../../data/content";

export default function LiveShowcase() {
  return (
    <section className="py-24 lg:py-32 border-t border-white/5 bg-navy-900/50" data-testid="live-showcase-section">
      <div className="container-x">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse-dot" />
              <p className="section-label">LIVE BUILD SHOWCASE</p>
            </div>
            <h2 className="mt-5 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white">
              WATCH US <span className="text-flame">BUILD.</span>
            </h2>
          </div>
          <Link to="/live-build" data-testid="showcase-view-all-link" className="inline-flex items-center gap-2 font-heading font-bold text-sm text-flame hover:gap-3 transition-all shrink-0">
            VIEW SHOWCASE <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SHOWCASE_CATEGORIES.map((c) => (
            <div
              key={c}
              data-testid={`showcase-tile-${c.toLowerCase().replace(/\s+/g, "-")}`}
              className="relative aspect-video rounded-2xl border border-white/10 bg-navy-800 overflow-hidden group card-lift"
            >
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
                <PlayCircle className="w-10 h-10 text-slate-600 group-hover:text-flame transition-colors" />
                <p className="font-mono text-[10px] tracking-[0.3em] text-slate-500">{c} — COMING SOON</p>
              </div>
              <div className="absolute top-4 left-4 flex items-center gap-2 rounded-full border border-white/10 bg-navy-900/80 px-3 py-1">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-500" />
                <span className="font-mono text-[9px] tracking-[0.2em] text-slate-400">RECORDING PLACEHOLDER</span>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-8 text-xs text-slate-600">Live build recordings, walkthroughs and before/after captures are published only with client consent.</p>
      </div>
    </section>
  );
}
